var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-dialog', _vm._b({
    staticClass: "v-dialog--img",
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function (_ref) {
        var attrs = _ref.attrs,
          on = _ref.on;
        return [_vm._t("activator", null, null, {
          attrs,
          on
        })];
      }
    }], null, true),
    model: {
      value: _vm.shows,
      callback: function ($$v) {
        _vm.shows = $$v;
      },
      expression: "shows"
    }
  }, 'v-dialog', _vm.$attrs, false), [_c('div', {
    staticClass: "v-dialog__inner"
  }, [_c('v-toolbar', {
    attrs: {
      "color": "transparent"
    }
  }, [_c('v-spacer'), _c('v-btn', {
    staticClass: "v-size--xx-large",
    attrs: {
      "icon": "",
      "tile": "",
      "color": "white"
    },
    on: {
      "click": function ($event) {
        $event.stopPropagation();
        return _vm.close.apply(null, arguments);
      }
    }
  }, [_c('u-icon', {
    attrs: {
      "color": "white--text"
    }
  }, [_vm._v("close")])], 1)], 1), _c('v-card', {
    attrs: {
      "flat": "",
      "tile": "",
      "color": "transparent",
      "width": "100%"
    }
  }, [_vm._t("default")], 2)], 1)]);

}
var staticRenderFns = []

export { render, staticRenderFns }